module.exports = __webpack_public_path__ + "assets/1ec6edd1fb94b1f4bb8744427ca990b9.mp3";